enum CommonRoutesEnum {
  Home = '/',
  SignUp = '/signup',
  Token = '/oauth/success',
  SelectAuth = '/auth-type',
  ServiceAgreement = '/service-agreement',
}

export default CommonRoutesEnum;
